import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	VyrobekndOzn: null as string | null,
	NdNr: null as string | null,
	SnNrText: null as string | null,
	SnndInfo: null as string | null,
	Kdc: null as string | null,
	Mnozstvi: null as number | null,
	SlevaDopor: null as number | null,
	PrumSkladPc: null as number | null,
	PcPevna: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
